import React from 'react';

import Icon, { Props } from './icon';

export const ReplayIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50015 6.98334C10.2457 6.98334 10.8501 7.58775 10.8501 8.33334V33.3333C10.8501 34.0789 10.2457 34.6833 9.50015 34.6833C8.75456 34.6833 8.15015 34.0789 8.15015 33.3333V8.33334C8.15015 7.58775 8.75456 6.98334 9.50015 6.98334Z"
        fill="#F2F2F2"
      />
      <path
        d="M13.0684 20.0772L32.0918 7.48823C32.6236 7.13629 33.3333 7.51765 33.3333 8.15537L33.3333 31.9346C33.3333 32.5533 32.6609 32.9378 32.1276 32.6241L13.1043 21.4339C12.5944 21.134 12.5751 20.4037 13.0684 20.0772Z"
        stroke="#F2F2F2"
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default React.memo(ReplayIcon);
